import styled from 'styled-components';

import { useCurrentUser } from '@/store/currentUser';
import { ViewPracticalAssessmentVideoPreviewEmbed } from '@/administration/pages/Course/pages/assessments/practicalAssessmentVideo/variants/View/ViewPracticalAssessmentVideoPreviewEmbed';
import { AuthorHeader } from '@/administration/pages/Course/pages/assessments/common/AuthorHeader';
import { ViewPracticalAssessmentVideoPreviewVimeo } from '@/administration/pages/Course/pages/assessments/practicalAssessmentVideo/variants/View/ViewPracticalAssessmentVideoPreviewVimeo';
import { SubmissionResultData } from '@/administration/pages/Course/pages/assessments/practicalAssessmentVideo/variants/View/types';
import { RUserLearningSubmissionReview } from '@/store/v2';
import { Divider } from '@/ui/Divider';
import { SubmittedReviews } from '@/administration/pages/Course/pages/assessments/common/reviews/PeersToReview/SubmittedReviews';

type ViewPracticalAssessmentVideoSubmissionResultProps = {
  createdAt: string;
  submissionResultData: SubmissionResultData;
  receivedReviews: RUserLearningSubmissionReview[];
  peerReviewEnabled: boolean;
};

const RootStyled = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.neutral.outline1};
  padding: 32px;
  gap: 32px;
  border-radius: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ViewPracticalAssessmentVideoSubmissionResult = ({
  submissionResultData,
  createdAt,
  receivedReviews,
  peerReviewEnabled,
}: ViewPracticalAssessmentVideoSubmissionResultProps): JSX.Element => {
  const { user } = useCurrentUser();

  return (
    <RootStyled>
      <AuthorHeader authorId={user?.id} createdAt={createdAt} />
      {submissionResultData.type === 'embed' ? (
        <ViewPracticalAssessmentVideoPreviewEmbed videoLink={submissionResultData.videoLink} rounded />
      ) : (
        <ViewPracticalAssessmentVideoPreviewVimeo
          uploadedFileVideo={{
            vimeoId: submissionResultData.vimeoId,
            thumbnail: submissionResultData.thumbnail,
            duration: submissionResultData.duration,
            ratio: submissionResultData.ratio,
          }}
          rounded
        />
      )}
      {peerReviewEnabled && (
        <>
          <Divider />
          <div>
            <SubmittedReviews reviews={receivedReviews} />
          </div>
        </>
      )}
    </RootStyled>
  );
};
